import React, {Component} from 'react'
import MarkUnprintedPage from './MarkUnprintedPage'

//import PropTypes from 'prop-types'

class MarkUnprintedPageContainer extends Component {
    render() {
        return (
            <div className='MarkUnprintedPageContainer'>
                <MarkUnprintedPage/>
            </div>
        )
    }
}

//MarkUnprintedPageContainer.defaultProps = {}

//MarkUnprintedPageContainer.propTypes = {}

export default MarkUnprintedPageContainer
